import axios from "axios";
//import FormData from "form-data";
import {AdminClientListEndPoint,AdminAddClientEndPoint, AdminDeleteClientEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//   return response;
// }, function (error) {
//   return Promise.reject(error.response);
// });

class AdminClientListServices {
  static getAdminClientList(pageNum) {
    if (!pageNum) {
      pageNum = 1;
    }
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    };
    return axios.get(AdminClientListEndPoint + "?page=" + pageNum, config);
  }

}

class AdminAddClientServices {
  static addAdminClient(data) {
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    }
    return axios.post(AdminAddClientEndPoint, data, config)
  }
}

class AdminDeleteClientServices {
  static deleteAdminClient(id) {
    const config = {
      headers: {"Authorization": GlobalConfig.Token}
    }
    return axios.delete(AdminDeleteClientEndPoint+"/"+id, config)
  }
}

export {AdminClientListServices, AdminAddClientServices,AdminDeleteClientServices};
